import(/* webpackMode: "eager" */ "/usr/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/usr/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/app/src/app/services/excel-nach-power-bi/components/DashboardLandingClient.tsx");
;
import(/* webpackMode: "eager" */ "/usr/app/src/assets/styles/pages.scss");
;
import(/* webpackMode: "eager" */ "/usr/app/src/components/features/guide/guide-read-next.css");
;
import(/* webpackMode: "eager" */ "/usr/app/src/components/features/guide/guide-contact.css");
